import { React, useState, useRef } from "react";
  


const TAB_Main = () => {
    const [data, setData] = useState([]); // state 초기화
   
    return (
        <div style={ { width:'100%' } }>
            <h1>{ localStorage.getItem("menu_name") }</h1>
        </div>
    )
}

export default TAB_Main;
